import { dispatch } from 'store';

import { SHOP_FOLLOW_SET, SHOP_FOLLOW_SYNC } from '../action-types/shop-follow.action-types';

export const setShopFollowState = (ownerId: number, liked: boolean) => dispatch({ type: SHOP_FOLLOW_SET, ownerId, liked });

export const syncShopFollowState = (entries: Record<number, boolean>) => dispatch({ type: SHOP_FOLLOW_SYNC, entries });

export const followEntries = (shops: { ownerId?: number; hasLiked?: boolean }[]): Record<number, boolean> =>
  shops.reduce(
    (entries, shop) => {
      if (shop?.ownerId && typeof shop.hasLiked === 'boolean') {
        entries[shop.ownerId] = shop.hasLiked;
      }

      return entries;
    },
    {} as Record<number, boolean>,
  );
